import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Eye from "../assets/icons/visibility-on.svg"
import EyeCut from "../assets/icons/visibility-off.svg"
import "../styles/componentsStyles/SignUp.scss"
import { toast } from 'react-toastify';
import Select from 'react-select';
import { FlagIcon } from 'react-flag-kit';
import countryData from '../resources/countries.json';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { BASE_URL } from '../api/api';
import { useCookies } from 'react-cookie';

const SignUp = () => {
    const [userDetails, setUserDetails] = useState({ firstName: "", lastName: "", username: "", email: "", countryCode: "", phone: "", dob: "", password: "", confirmPassword: "" });
    const [OTP, setOTP] = useState("");
    const [showOTPVerificationForm, setShowOTPVerificationForm] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isSendAgainOTPVisible, setIsSendAgainOTPVisible] = useState(false);
    const [countdownForOTP, setCountdownForOTP] = useState(30);
    const [cookies, setCookie] = useCookies(['token', 'userId', 'isLoggedIn']);

    const navigate = useNavigate();

    const countryOptions = countryData.map((country) => ({
        value: country.phone,
        label: country.name,
        flag: country.flag,
    }));

    const notifyInvalidDOB = () => toast("❌ Invalid Date Of Birth");
    const notifyInvalidPhoneNumber = (message) => toast(`📵 ${message}`);
    const notifyUserExists = () => toast("👱 User Already Exists");
    const notifyOTPSentAgain = () => toast("✅ OTP Sent Again");

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleToggleConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    // For Date Of Birth
    const today = new Date();
    const maxDate = today.toISOString().split('T')[0];

    // Do not allow any character in FULL NAME except Alphabets 
    const handleFirstName = (event) => {
        // Regular expression to allow only alphabets and spaces (A-Z, a-z, and space)
        const regex = /^[A-Za-z ]+$/;
        const value = event.target.value;

        if (regex.test(value) || value === '') {
            setUserDetails({ ...userDetails, firstName: value });
        }
    }

    const handleLastName = (event) => {
        // Regular expression to allow only alphabets (A-Z, a-z)
        const regex = /^[A-Za-z]+$/;
        const value = event.target.value;

        if (regex.test(value) || value === '') {
            setUserDetails({ ...userDetails, lastName: value });
        }
    }

    const handleUsername = (event) => {
        // Regular expression to disallow spaces and "@" symbol
        const regex = /^[a-zA-Z0-9]+$/;
        const value = event.target.value;

        if (regex.test(value) || value === '') {
            setUserDetails({ ...userDetails, username: value });
        }
    }

    const handlePhoneScroll = (e) => {
        e.target.blur();
    };

    const handlePhoneNumber = (e) => {
        const inputValue = e.target.value;
        // Check if input is numeric and has at most 10 digits
        if (/^\d{0,10}$/.test(inputValue)) {
            setUserDetails({ ...userDetails, phone: inputValue })
        }
    };

    const customOptionRenderer = (option) => (
        <div className='sign-up__country-code-container'>
            <FlagIcon code={option.flag} />
            <span style={{ marginLeft: '10px' }}>{option.value} &nbsp;{option.label}</span>
        </div>
    );

    // console.log(countryOptions);
    const handleCountryCode = (countryCodeValue) => {
        console.log(countryCodeValue, "countryCodeValue");
        setUserDetails({
            ...userDetails, countryCode: countryCodeValue
        });
    };

    const submitSignUp = (e) => {
        e.preventDefault();
        let isValid = true;

        if (userDetails.password !== userDetails.confirmPassword) {
            alert("Password and Confirm Password must be same");
            isValid = false
        }

        if (!/^\d{10}$/.test(userDetails.phone)) {
            notifyInvalidPhoneNumber("Enter Valid Mobile Number");
            isValid = false
        }

        // If everything is valid, proceed with form submission
        if (isValid) {
            window.scrollTo(0, 0);
            document.body.classList.add('stop-scrolling');

            axios.post(`${BASE_URL}/api/auth/get-otp`, { email: userDetails.email })
                .then(res => {
                    if (res.data.statusText === "success") {
                        setShowOTPVerificationForm(true);
                        // OTP resend coutdown
                        startCountdown();
                    }
                }
                )
                .catch(err => console.log(err))
        }
    }

    const verifyEmailandCreateUser = (e) => {
        e.preventDefault();

        axios.post(`${BASE_URL}/api/auth/verify-email`, { otp: OTP, email: userDetails.email })
            .then(res => {
                console.log(res);
                if (res.data.statusText === "success") {
                    signUpUser();
                    setShowOTPVerificationForm(false);
                    document.body.classList.remove('stop-scrolling');

                    // timer of Send Again OTP button visibility
                    setTimeout(() => {
                        setIsSendAgainOTPVisible(true);
                    }, 30000);
                }
            })
            .catch(err => console.log(err))
    }

    function signUpUser() {
        // Generate UniqueID for user (i.e, userId) 
        const uniqueUserID = uuidv4();

        console.log(userDetails.countryCode);

        const formData = {
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
            username: userDetails.username,
            email: userDetails.email,
            countryCode: userDetails.countryCode.value,
            phone: userDetails.phone,
            userId: uniqueUserID,
            // dateOfBirth: userDetails.dob !== "" ? userDetails.dob : "",
            // channelId: "channel-not-created",
            // followedChannels: [],
            // isPremiumUser: false,
            // type: "user", default
            password: userDetails.password
        }

        axios.post(`${BASE_URL}/api/auth/sign-up`, formData)
            .then(res => {
                console.log(res);
                if (res.data.statusText === "success") {
                    autoLoginUser();
                    console.log(res);
                }
                if (res.data.status === "user-already-exists") {
                    notifyUserExists();
                }
            })
            .catch(err => console.log(err))
    }

    function autoLoginUser() {
        const loginInfo = {
            query: userDetails.username,
            password: userDetails.password
        }
        console.log(loginInfo);

        axios.post(`${BASE_URL}/api/auth/login`, loginInfo)
            .then(res => {
                console.log(res);
                if (res.data.statusText === "success") {
                    // Perform authentication, and if successful:
                    // Store token, userId, and login status in cookies
                    setCookie('token', res.data.token, { path: '/' });
                    setCookie('userId', res.data.userId, { path: '/' });
                    setCookie('isLoggedIn', true, { path: '/' });
                    navigate('/');

                    // Reset form fields
                    setUserDetails({ ...userDetails, firstName: "", lastName: "", username: "", email: "", countryCode: "", phone: "", dob: "", password: "", confirmPassword: "" });

                    fetchUserDetails(res.data.userId);
                }
            })
            .catch(err => console.log(err))
    }

    function fetchUserDetails(userID) {
        console.log(userID, "userID");
        axios.post(`${BASE_URL}/api/auth/fetch-user-details`, { userId: userID })
            .then(res => console.log(res))
            .catch(err => console.log(err))
    }

    // get user country (check ipapi if free to use or not then implement)
    // useEffect(() => {
    //     axios.get('https://ipapi.co/json/')
    //         .then(function (response) {
    //             console.log(response);
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         })
    // }, [])

    useEffect(() => {
        if (!showOTPVerificationForm) {
            document.body.classList.remove('stop-scrolling');
        }
    }, [showOTPVerificationForm])

    const sendOtpAgain = () => {
        axios.post(`${BASE_URL}/api/auth/resend-otp`, { email: userDetails.email })
            .then(res => {
                if (res.data.statusText === "success") {
                    notifyOTPSentAgain();
                    startCountdown();
                    setIsSendAgainOTPVisible(false);
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    // countdown for resending OTP on email 
    function startCountdown() {
        setCountdownForOTP(30);
        const timer = setInterval(() => {
            setCountdownForOTP((prevCount) => prevCount - 1);
        }, 1000);

        setTimeout(() => {
            setIsSendAgainOTPVisible(true);
            clearInterval(timer);
        }, 30000);
    };

    return (
        <div className='sign-up'>
            <h3 className="sign-up__company-logo">ProjectY</h3>
            <Link to="/login" className="sign-up__login-link-top">Already a user? <span>Login</span></Link>
            <div className="sign-up__container">
                <h3 className='sign-up__title'>
                    <p>Create a new account (Sign Up)</p>
                    {/* <p>Sign Up</p> */}
                </h3>
                <form className='sign-up__form' action="" onSubmit={submitSignUp}>

                    <div className="sign-up__name-container">
                        <div className="sign-up__input-group">
                            <label htmlFor="sign-up__first-name" className='sign-up__label'>First Name</label>
                            <input id='sign-up__first-name' type="text" placeholder='Enter your first name' autoFocus value={userDetails.firstName} onChange={handleFirstName} minLength={3} maxLength={60} required />
                        </div>
                        <div className="sign-up__input-group">
                            <label htmlFor="sign-up__last-name" className='sign-up__label'>Last Name</label>
                            <input id='sign-up__last-name' type="text" placeholder='Enter your last name' value={userDetails.lastName} onChange={handleLastName} minLength={3} maxLength={30} required />
                        </div>
                    </div>

                    <div className="sign-up__input-group">
                        <label htmlFor="sign-up__username" className='sign-up__label'>Create Username</label>
                        <input id='sign-up__username' type="text" placeholder='Create unique username' value={userDetails.username} onChange={handleUsername} minLength={7} maxLength={30} required />
                    </div>

                    <div className="sign-up__input-group">
                        <label htmlFor="sign-up__email" className='sign-up__label'>Email</label>
                        <input id='sign-up__email' type="email" value={userDetails.email} placeholder='Enter your email' onChange={(e) => setUserDetails({ ...userDetails, email: e.target.value })} required />
                    </div>

                    <div className="sign-up__input-group">
                        <label htmlFor="sign-up__number" className='sign-up__label'>Mobile No. <span>(Optional)</span></label>
                        <div className="sign-up__phone-container">
                            <Select className='sign-up__country-code-select'
                                value={userDetails.countryCode}
                                onChange={handleCountryCode}
                                options={countryOptions}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                formatOptionLabel={customOptionRenderer}
                                placeholder="country code"
                            />

                            <input id='sign-up__number' type="text" placeholder='Enter your mobile number' value={userDetails.phone} onWheel={handlePhoneScroll} onChange={handlePhoneNumber} />
                        </div>
                    </div>

                    <div className="sign-up__input-group">
                        <label htmlFor="sign-up__dob" className='sign-up__label'>Date of Birth <span>(Optional)</span></label>
                        <input id='sign-up__dob' type="date" value={userDetails.dob} max={maxDate} onChange={(e) => setUserDetails({ ...userDetails, dob: e.target.value })} />
                    </div>

                    <div className="sign-up__input-group">
                        <label htmlFor="sign-up__password" className='sign-up__label'>Password</label>
                        <div className="sign-up__password-container">
                            <input id='sign-up__password' type={showPassword ? 'text' : 'password'} placeholder='Create strong passowrd' value={userDetails.password} onChange={(e) => setUserDetails({ ...userDetails, password: e.target.value })} minLength={9} required />
                            <button type="button" onClick={handleTogglePassword}>
                                {showPassword ? <img src={Eye} alt="show" /> : <img src={EyeCut} alt="hide" />}
                            </button>
                        </div>
                    </div>

                    <div className="sign-up__input-group">
                        <label htmlFor="sign-up__confirm-password" className='sign-up__label'>Confirm Password</label>
                        <div className="sign-up__password-container">
                            <input id='sign-up__confirm-password' type={showConfirmPassword ? 'text' : 'password'} placeholder='Confirm your passowrd' value={userDetails.confirmPassword} onChange={(e) => setUserDetails({ ...userDetails, confirmPassword: e.target.value })} required />
                            <button type="button" onClick={handleToggleConfirmPassword}>
                                {showConfirmPassword ? <img src={Eye} alt="show" /> : <img src={EyeCut} alt="hide" />}
                            </button>
                        </div>
                    </div>

                    <div className="sign-up__login-link">
                        <p>Already a user?  <Link to="/login">Login</Link></p>
                    </div>

                    <div className="sign-up__btn-container">
                        <button className='sign-up__button' type='submit'>Sign Up</button>
                    </div>
                </form>
            </div>

            {showOTPVerificationForm && <div className="sign-up__verify-email-container">
                <div className="sign-up__verify-email-box">
                    <span className="sign-up__close-btn material-symbols-outlined" onClick={() => setShowOTPVerificationForm(false)}>
                        close
                    </span>
                    <form action="" onSubmit={verifyEmailandCreateUser} className="sign-up__verify-email-form">
                        <label htmlFor="verify-email">Verify Email</label>
                        <p>Enter OTP sent on {userDetails.email}</p>

                        <div className="sign-up__verify-email-input">
                            <div className="sign-up__lock">
                                <span className="material-symbols-outlined">
                                    lock
                                </span>
                            </div>
                            <input type="text" id="verify-email" placeholder='OTP' value={OTP} onChange={(e) => setOTP(e.target.value)} autoFocus />
                        </div>
                        {
                            isSendAgainOTPVisible ? <div className='sign-up__send-again-otp' onClick={sendOtpAgain}>Not recieved OTP? <button>Send Again</button></div> : <div className='sign-up__send-again-otp' >Resend OTP in: {countdownForOTP}</div>
                        }

                        <button type='submit' className='sign-up__verify-otp-btn'>Verify</button>
                    </form>
                </div>
            </div>}
        </div>
    )
}

export default SignUp